import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Form from "../components/Form";
import useAuth from "../hooks/useAuth";
import { loginValidationSchema } from "../validationSchemas/loginValidationSchema";
import ErrorDisplay from "../components/ErrorDisplay";

const Login = () => {
  const { login, error } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSubmit = async (formValues) => {
    await login(formValues.username, formValues.password);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: { xs: 2, sm: 3 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", sm: "400px", md: "450px" },
          padding: { xs: 2, sm: 3 },
          textAlign: "center",
        }}
      >
        {/* Logo */}
        <Box sx={{ mb: 3, textAlign: "center" }}>
          <img
            src="/images/Apistoki-Logo-Rectangular-1.png"
            alt="Logo"
            style={{
              width: isMobile ? "200px" : "250px",
              height: "auto",
              maxWidth: "100%",
            }}
          />
        </Box>

        <Form
          title="Login to Your Account"
          fields={[
            { name: "username", label: "Username" },
            { name: "password", label: "Password", type: "password" },
          ]}
          onSubmit={handleSubmit}
          buttonText="Login"
          validationSchema={loginValidationSchema}
        />
        
        {/* Display the error below the form */}
        {error && <ErrorDisplay error={error} />}
      </Box>
    </Box>
  );
};

export default Login;
